module.exports = __webpack_public_path__ + "202669:9205d1a92be8207f1496/img/hero-mobile@2x.15234e9.jpg";